(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ame-breadcrumb"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function update(list) {
      var atStart = list.scrollLeft <= 1;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
      list.classList.toggle('is-at-start', atStart);
      list.classList.toggle('is-at-end', atEnd);
    }

    function init() {
      document.querySelectorAll('.ame-breadcrumb__list').forEach(function(list) {
        if (list.dataset.breadcrumbInit) return;
        list.dataset.breadcrumbInit = '1';
        list.addEventListener('scroll', function() { update(list); }, { passive: true });
        update(list);
      });
    }

    function updateAll() {
      document.querySelectorAll('.ame-breadcrumb__list').forEach(update);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('resize', updateAll, { passive: true });
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ame-entreprises-prestations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupCarousel(section) {
      if (section.dataset.mobileCarouselSetup) return;
      if (section.dataset.mobileCarousel !== 'true') return;

      const grid = section.querySelector('.ame-prestations__grid');
      if (!grid) return;

      const cards = grid.querySelectorAll('.ame-prestations__card');
      if (cards.length === 0) return;

      const wrap = document.createElement('div');
      wrap.className = 'ame-prestations__cards-wrap';

      const firstCard = cards[0];
      firstCard.parentNode.insertBefore(wrap, firstCard);

      cards.forEach((card) => wrap.appendChild(card));

      section.dataset.mobileCarouselSetup = 'true';
    }

    document.querySelectorAll('.ame-prestations').forEach(setupCarousel);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        document.querySelectorAll('.ame-prestations').forEach((section) => {
          delete section.dataset.mobileCarouselSetup;
          setupCarousel(section);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ame-entreprises-process"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad2(n) {
      return String(n).padStart(2, '0');
    }

    function setupCarousel(section) {
      if (section.dataset.processSetup === 'true') return;

      const layout = section.querySelector('.ame-process__layout');
      if (!layout) return;

      const steps = Array.from(layout.querySelectorAll('.ame-process__step'));
      if (steps.length === 0) return;

      const counter = section.querySelector('.ame-process__counter');
      const currentEl = counter ? counter.querySelector('[data-process-current]') : null;
      const totalEl = counter ? counter.querySelector('[data-process-total]') : null;

      let wrap = layout.querySelector('.ame-process__carousel-wrap');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'ame-process__carousel-wrap';
        steps[0].parentNode.insertBefore(wrap, steps[0]);
        steps.forEach((step) => wrap.appendChild(step));
      }

      if (counter && totalEl) {
        totalEl.textContent = pad2(steps.length);
      }

      const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

      if (counter) {
        counter.hidden = !isMobile();
        counter.setAttribute('aria-hidden', isMobile() ? 'false' : 'true');
      }

      window.addEventListener('resize', () => {
        if (counter) {
          counter.hidden = !isMobile();
          counter.setAttribute('aria-hidden', isMobile() ? 'false' : 'true');
        }
      }, { passive: true });

      if (counter && currentEl && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            let bestEntry = null;
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
                  bestEntry = entry;
                }
              }
            });
            if (bestEntry) {
              const idx = steps.indexOf(bestEntry.target);
              if (idx >= 0) {
                currentEl.textContent = pad2(idx + 1);
              }
            }
          },
          {
            root: wrap,
            threshold: [0.4, 0.6, 0.8, 1],
            rootMargin: '0px'
          }
        );
        steps.forEach((step) => observer.observe(step));
      }

      section.dataset.processSetup = 'true';
    }

    document.querySelectorAll('.ame-process').forEach(setupCarousel);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        document.querySelectorAll('.ame-process').forEach((section) => {
          delete section.dataset.processSetup;
          setupCarousel(section);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ame-faq-toc"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function update(list) {
      var atStart = list.scrollLeft <= 1;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
      list.classList.toggle('is-at-start', atStart);
      list.classList.toggle('is-at-end', atEnd);
    }

    function init() {
      document.querySelectorAll('.ame-faq-toc__grid').forEach(function(list) {
        if (list.dataset.faqTocInit) return;
        list.dataset.faqTocInit = '1';
        list.addEventListener('scroll', function() { update(list); }, { passive: true });
        update(list);
      });
    }

    function updateAll() {
      document.querySelectorAll('.ame-faq-toc__grid').forEach(update);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('resize', updateAll, { passive: true });
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ame-press-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-press-section]');
    if (!sections.length) return;

    function attachSection(section) {
      if (section.dataset.pressInit === 'true') return;
      section.dataset.pressInit = 'true';

      var dialog = section.querySelector('[data-press-dialog]');
      if (!dialog) return;

      var refs = {
        magazine: section.querySelector('[data-press-dialog-magazine]'),
        date: section.querySelector('[data-press-dialog-date]'),
        cover: section.querySelector('[data-press-dialog-cover]'),
        article: section.querySelector('[data-press-dialog-article]'),
        articleFigure: section.querySelector('[data-press-dialog-article-figure]'),
        excerpt: section.querySelector('[data-press-dialog-excerpt]')
      };

      function openDialog() {
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); }
          catch (err) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        document.body.style.overflow = 'hidden';
      }

      function closeDialog() {
        if (typeof dialog.close === 'function') {
          try { dialog.close(); }
          catch (err) { dialog.removeAttribute('open'); }
        } else {
          dialog.removeAttribute('open');
        }
        document.body.style.overflow = '';
      }

      section.addEventListener('click', function (event) {
        var closeTarget = event.target.closest('[data-press-close]');
        if (closeTarget) {
          event.preventDefault();
          closeDialog();
          return;
        }
        var trigger = event.target.closest('[data-press-trigger]');
        if (!trigger) return;

        var item = trigger.closest('[data-press-item]');
        if (!item) return;
        var ds = item.dataset;

        if (refs.magazine) refs.magazine.textContent = ds.magazine || '';
        if (refs.date) refs.date.textContent = ds.date || '';

        if (refs.cover) {
          if (ds.coverSrc) {
            refs.cover.src = ds.coverSrc;
            refs.cover.alt = ds.coverAlt || '';
            refs.cover.parentElement.hidden = false;
          } else {
            refs.cover.removeAttribute('src');
            refs.cover.parentElement.hidden = true;
          }
        }

        if (refs.article) {
          if (ds.articleSrc) {
            refs.article.src = ds.articleSrc;
            refs.article.alt = ds.articleAlt || '';
            if (refs.articleFigure) refs.articleFigure.hidden = false;
          } else {
            refs.article.removeAttribute('src');
            if (refs.articleFigure) refs.articleFigure.hidden = true;
          }
        }

        if (refs.excerpt) {
          if (ds.excerpt) {
            refs.excerpt.textContent = '« ' + ds.excerpt + ' »';
            refs.excerpt.hidden = false;
          } else {
            refs.excerpt.textContent = '';
            refs.excerpt.hidden = true;
          }
        }

        openDialog();
      });

      dialog.addEventListener('close', function () {
        document.body.style.overflow = '';
      });

      dialog.addEventListener('cancel', function () {
        document.body.style.overflow = '';
      });

      var items = section.querySelectorAll('.press-item');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(items, function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      Array.prototype.forEach.call(items, function (item) {
        item.classList.add('is-hidden');
      });

      var itemsArr = Array.prototype.slice.call(items);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = itemsArr.indexOf(entry.target);
          var delay = Math.min(idx, 6) * 90;
          setTimeout(function () {
            entry.target.classList.remove('is-hidden');
            entry.target.classList.add('is-visible');
          }, delay);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      itemsArr.forEach(function (item) { observer.observe(item); });
    }

    Array.prototype.forEach.call(sections, attachSection);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        var section = event.target.querySelector ? event.target.querySelector('[data-press-section]') : null;
        if (section) attachSection(section);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ame-projets-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const grids = document.querySelectorAll('.ame-projets-grid');
    if (!grids.length) return;

    grids.forEach((grid) => {
      const list = grid.querySelector('.ame-projets-grid__list');
      if (!list) return;

      const cards = Array.from(list.querySelectorAll('.ame-projets-grid__card'));
      const pills = grid.querySelectorAll('.ame-projets-grid__pill');
      const moreBtn = grid.querySelector('[data-load-more]');
      const emptyState = grid.querySelector('[data-empty-state]');
      const maxVisible = parseInt(grid.dataset.maxVisible || '12', 10);

      let activeFilter = '*';
      let isExpanded = false;

      const applyVisibility = () => {
        let visibleCount = 0;
        let totalMatchingFilter = 0;

        cards.forEach((card) => {
          const matchesFilter = activeFilter === '*' || card.dataset.category === activeFilter;
          card.classList.toggle('is-filtered-out', !matchesFilter);

          if (!matchesFilter) {
            card.classList.remove('is-hidden-overflow');
            return;
          }

          totalMatchingFilter += 1;

          if (!isExpanded && visibleCount >= maxVisible) {
            card.classList.add('is-hidden-overflow');
          } else {
            card.classList.remove('is-hidden-overflow');
            visibleCount += 1;
          }
        });

        if (emptyState) {
          emptyState.hidden = totalMatchingFilter > 0;
        }

        if (moreBtn) {
          const needsToggle = totalMatchingFilter > maxVisible;
          moreBtn.hidden = !needsToggle;
        }
      };

      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          const filter = pill.dataset.filter || '*';
          if (filter === activeFilter) return;

          activeFilter = filter;
          pills.forEach((p) => {
            const isActive = p === pill;
            p.classList.toggle('is-active', isActive);
            p.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          isExpanded = false;
          if (moreBtn) {
            moreBtn.setAttribute('aria-expanded', 'false');
            const collapsed = moreBtn.querySelector('[data-load-more-label-collapsed]');
            const expanded = moreBtn.querySelector('[data-load-more-label-expanded]');
            if (collapsed) collapsed.hidden = false;
            if (expanded) expanded.hidden = true;
          }

          applyVisibility();
        });
      });

      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          isExpanded = !isExpanded;
          moreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

          const collapsed = moreBtn.querySelector('[data-load-more-label-collapsed]');
          const expanded = moreBtn.querySelector('[data-load-more-label-expanded]');
          if (collapsed) collapsed.hidden = isExpanded;
          if (expanded) expanded.hidden = !isExpanded;

          applyVisibility();
        });
      }

      applyVisibility();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
